/**
 * accordion.js — accordion câu hỏi thường gặp + chip lọc nhóm (mục 30 · FAQs).
 *
 * Markup cần:
 *   [data-accordion] > .accordion__item#<slug>[data-faq-cat="<nhóm>"]
 *       > .accordion__heading > button.accordion__toggle[aria-expanded][aria-controls]
 *       + .accordion__panel#<slug>-a
 *   [data-faq-list]                   — accordion chịu tác động của chip lọc
 *   button[data-faq-filter="<nhóm>"]  — chip lọc, "all" = Tất cả; trạng thái ở aria-pressed
 *   [data-faq-status="%1$s: %2$d …"]  — vùng aria-live (tuỳ chọn). Câu chữ nằm trong HTML
 *                                       chứ không trong JS để PHP dịch được (esc_attr__)
 *
 * Hành vi theo guideline:
 *   · Mỗi lần mở MỘT câu — mở câu mới thì câu cũ đóng; bấm lại câu đang mở thì đóng hẳn.
 *   · Đổi nhóm thì mở sẵn câu đầu của nhóm, câu không thuộc nhóm ẩn đi (giữ nguyên thứ tự).
 *   · Deep link faqs.html#doi-tra mở đúng câu đó; câu đang bị lọc ẩn thì bỏ lọc trước.
 *     Mở câu nào thì ghi #id lên URL (replaceState, không thêm lịch sử) để copy link gửi đi.
 *
 * Câu đầu được in sẵn .is-open trong HTML nên không có JS vẫn đọc được câu đầu; các câu
 * còn lại cần JS để mở — chấp nhận được vì đây là trang nội dung phụ.
 *
 * WP: page-faqs.php in vòng lặp Meta Box group; id = slug câu hỏi. File này không đổi.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var lists = [].slice.call(document.querySelectorAll('[data-accordion]'));
    if (!lists.length) return;

    function itemsOf(list) {
        return [].slice.call(list.querySelectorAll('.accordion__item'));
    }

    function setOpen(item, open) {
        item.classList.toggle('is-open', open);

        var toggle = item.querySelector('.accordion__toggle');
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // Mở đúng một câu, đóng mọi câu còn lại trong cùng accordion (target null = đóng hết)
    function openOnly(list, target) {
        itemsOf(list).forEach(function (item) {
            setOpen(item, item === target);
        });
    }

    function replaceHash(id) {
        if (!window.history || !window.history.replaceState) return;

        var url = window.location.pathname + window.location.search + (id ? '#' + id : '');
        window.history.replaceState(null, '', url);
    }

    lists.forEach(function (list) {
        list.addEventListener('click', function (event) {
            var toggle = event.target.closest ? event.target.closest('.accordion__toggle') : null;
            if (!toggle || !list.contains(toggle)) return;

            var item = toggle.closest('.accordion__item');
            if (!item) return;

            if (item.classList.contains('is-open')) {
                setOpen(item, false);
                // Đóng câu đang nằm trên URL thì gỡ #id, kẻo F5 lại bung đúng câu vừa đóng
                if (item.id && window.location.hash === '#' + item.id) replaceHash('');
                return;
            }

            openOnly(list, item);
            if (item.id) replaceHash(item.id);
        });
    });

    // ----- Chip lọc nhóm -----
    var faqList = document.querySelector('[data-faq-list]');
    var chips = [].slice.call(document.querySelectorAll('[data-faq-filter]'));
    var status = document.querySelector('[data-faq-status]');

    function applyFilter(cat, openFirst) {
        if (!faqList) return;

        var label = '';
        chips.forEach(function (chip) {
            var on = chip.getAttribute('data-faq-filter') === cat;
            chip.setAttribute('aria-pressed', on ? 'true' : 'false');
            if (on) label = chip.textContent.trim();
        });

        var shown = itemsOf(faqList).filter(function (item) {
            var match = cat === 'all' || item.getAttribute('data-faq-cat') === cat;
            item.hidden = !match;
            return match;
        });

        // Giống bản vẽ: đổi nhóm là mở sẵn câu đầu của nhóm đó
        if (openFirst) {
            openOnly(faqList, shown[0] || null);
            replaceHash('');
        }

        if (status) {
            status.textContent = status.getAttribute('data-faq-status')
                .replace('%1$s', label)
                .replace('%2$d', String(shown.length));
        }
    }

    chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
            // Bấm lại chip đang chọn thì thôi, đừng đóng câu người dùng đang đọc
            if (chip.getAttribute('aria-pressed') === 'true') return;
            applyFilter(chip.getAttribute('data-faq-filter'), true);
        });
    });

    // ----- Deep link #id -----
    function fromHash() {
        var id = window.location.hash.slice(1);
        if (!id) return;

        try {
            id = decodeURIComponent(id);
        } catch (e) {
            return;
        }

        var target = document.getElementById(id);
        var item = target && target.closest ? target.closest('.accordion__item') : null;
        if (!item) return;

        var list = item.closest('[data-accordion]');
        if (!list) return;

        // Tắt chuyển động một nhịp: câu cũ co lại / câu mới bung ra có hiệu ứng thì lúc
        // cuộn tới, câu đích còn đang trôi — dừng lệch cả chục pixel so với đầu câu.
        list.classList.add('is-instant');

        if (item.hidden) applyFilter('all', false);
        openOnly(list, item);

        // Trình duyệt đã tự cuộn tới #id TRƯỚC khi câu đầu kịp đóng → cuộn lại lần nữa
        // trên bố cục cuối. scroll-margin-top trong CSS chừa chỗ cho header dính.
        item.scrollIntoView({ block: 'start' });

        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                list.classList.remove('is-instant');
            });
        });
    }

    window.addEventListener('hashchange', fromHash);
    fromHash();
})();
